import type { Prisma } from "@gt/prisma";

export type UserWithCompany = Prisma.UserGetPayload<{ include: { company: true } }>;

/** Company has passed external/system verification — full app routes allowed. */
export const CLIENT_ONBOARDING_COMPLETE_STATUSES = new Set(["SYSTEM_VERIFIED", "VERIFIED"]);

export function isClientOnboardingComplete(user: UserWithCompany | null | undefined): boolean {
  const status = user?.company?.status;
  return Boolean(user?.company && status && CLIENT_ONBOARDING_COMPLETE_STATUSES.has(status));
}

/** Where to send a CLIENT after auth when using default app shell (not admin). */
export function getDefaultClientPathAfterAuth(
  user: UserWithCompany | null | undefined,
): "/my-discovery" | "/create-profile" {
  const hasCreatedProfile = Boolean(user?.company?.website);
  if (hasCreatedProfile) return "/my-discovery";
  return "/create-profile";
}
